import { render } from "./ComponentTextMiningSyntax.vue?vue&type=template&id=0a0561e1&scoped=true"
import script from "./ComponentTextMiningSyntax.vue?vue&type=script&lang=js"
export * from "./ComponentTextMiningSyntax.vue?vue&type=script&lang=js"

import "./ComponentTextMiningSyntax.vue?vue&type=style&index=0&id=0a0561e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0561e1"]])

export default __exports__